/**
 * Meta Pixel + Shopify checkout config.
 * Everything that ever needs changing lives at the top of this file.
 */
export const PIXEL_ID = '676572141744167'

export type CheckoutPlanId = 'starter' | 'complete'
export type UpsellVariantId = 'braveMind' | 'littleEngineer' | 'focusLab'

export const PLAN_META: Record<CheckoutPlanId, { contentName: string; value: number }> = {
  complete: { contentName: 'Calm Mornings Complete', value: 37.0 },
  starter: { contentName: 'Calm Mornings Starter', value: 27.0 },
}

/**
 * Fixed lookup table. Key = braveMind + littleEngineer + focusLab, "1" checked.
 */
export const CHECKOUT_URLS: Record<CheckoutPlanId, Record<string, string>> = {
  complete: {
    '000': 'https://myeasyguide.online/cart/49960131133682:1',
    '100': 'https://myeasyguide.online/cart/49960131133682:1,49930211688690:1',
    '010': 'https://myeasyguide.online/cart/49960131133682:1,49902595670258:1',
    '001': 'https://myeasyguide.online/cart/49960131133682:1,49945662128370:1',
    '110':
      'https://myeasyguide.online/cart/49960131133682:1,49930211688690:1,49902595670258:1',
    '101':
      'https://myeasyguide.online/cart/49960131133682:1,49930211688690:1,49945662128370:1',
    '011':
      'https://myeasyguide.online/cart/49960131133682:1,49902595670258:1,49945662128370:1',
    '111':
      'https://myeasyguide.online/cart/49960131133682:1,49930211688690:1,49902595670258:1,49945662128370:1',
  },
  starter: {
    '000': 'https://myeasyguide.online/cart/49960130478322:1',
    '100': 'https://myeasyguide.online/cart/49960130478322:1,49930211688690:1',
    '010': 'https://myeasyguide.online/cart/49960130478322:1,49902595670258:1',
    '001': 'https://myeasyguide.online/cart/49960130478322:1,49945662128370:1',
    '110':
      'https://myeasyguide.online/cart/49960130478322:1,49930211688690:1,49902595670258:1',
    '101':
      'https://myeasyguide.online/cart/49960130478322:1,49930211688690:1,49945662128370:1',
    '011':
      'https://myeasyguide.online/cart/49960130478322:1,49902595670258:1,49945662128370:1',
    '111':
      'https://myeasyguide.online/cart/49960130478322:1,49930211688690:1,49902595670258:1,49945662128370:1',
  },
}

declare global {
  interface Window {
    fbq?: ((...args: unknown[]) => void) & {
      callMethod?: (...args: unknown[]) => void
      queue?: unknown[]
      push?: unknown
      loaded?: boolean
      version?: string
    }
    _fbq?: unknown
    __metaPixelInitialized?: boolean
  }
}

/** Injects the base code. Safe to call more than once — init only ever runs once. */
export function initMetaPixel(): void {
  if (typeof window === 'undefined' || window.__metaPixelInitialized) return
  window.__metaPixelInitialized = true

  /* eslint-disable */
  ;(function (f: any, b: Document, e: string, v: string) {
    if (f.fbq) return
    const n: any = (f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    })
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []
    const t = b.createElement(e) as HTMLScriptElement
    t.async = true
    t.src = v
    const s = b.getElementsByTagName(e)[0]
    s.parentNode?.insertBefore(t, s)
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js')
  /* eslint-enable */

  window.fbq?.('init', PIXEL_ID)
  window.fbq?.('track', 'PageView')
  window.fbq?.('track', 'ViewContent', {
    content_name: 'Calm Mornings Mega Kit',
    content_type: 'product',
    value: 37.0,
    currency: 'USD',
  })

  const noscript = document.createElement('noscript')
  const img = document.createElement('img')
  img.height = 1
  img.width = 1
  img.style.display = 'none'
  img.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`
  img.alt = ''
  noscript.appendChild(img)
  document.body.appendChild(noscript)
}

type CheckoutOptions = {
  extras?: UpsellVariantId[]
  /** Order total, including the extras. Defaults to the plan price. */
  value?: number
}

/** Fires InitiateCheckout, then navigates to the looked-up cart URL, same tab. */
export function startCheckout(planId: CheckoutPlanId, options: CheckoutOptions = {}): void {
  const extras = options.extras ?? []
  const key =
    (extras.includes('braveMind') ? '1' : '0') +
    (extras.includes('littleEngineer') ? '1' : '0') +
    (extras.includes('focusLab') ? '1' : '0')

  const url = CHECKOUT_URLS[planId][key]
  console.log('CART URL:', url)

  window.fbq?.('track', 'InitiateCheckout', {
    value: options.value ?? PLAN_META[planId].value,
    currency: 'USD',
    content_name: PLAN_META[planId].contentName,
    content_type: 'product',
  })

  window.setTimeout(() => {
    window.location.href = url
  }, 150)
}
